/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Paper from "@mui/material/Paper";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import HighlightBox from "../../Box/HighlightBox/HighlightBox";
import { useForm } from "../../../provider/Form/FormProvider";
import Typography from "@mui/material/Typography";
import FormSubmitProps from "../../../types/FormSubmitProps";
import wizardStyle from "../wizardStyle";
import { Box } from "@mui/material";

type IntroProps = {
  submitProps: FormSubmitProps;
};

export default function Intro({ submitProps }: IntroProps) {
  const { handleSubmit } = useForm();
  return (
    <Paper elevation={4} sx={wizardStyle.paper}>
      <Box component={"form"} sx={wizardStyle.wizardForm} onSubmit={handleSubmit}>
        <Typography variant={"h4"} sx={wizardStyle.question}>
          Wie funktioniert der Verfahrenskostenhilfe-Assistent?
        </Typography>
        <br />
        <Typography variant={"h6"} sx={wizardStyle.primary}>
          1. Formular ausfüllen
        </Typography>
        <p>
          Füllen Sie in Ruhe das Formular aus. Wenn Sie etwas nachsehen möchten, können Sie die Eingabe jederzeit unterbrechen und dann zu einem anderen
          Zeitpunkt weiter ausfüllen. Bei Klick auf „weiter“ werden Ihre Angaben immer gespeichert.
        </p>
        <Typography variant={"h6"} sx={wizardStyle.primary}>
          2. Unterzeichnen
        </Typography>
        <p>Sie können das fertige Formular direkt auf Ihrem Handy oder PC unterzeichnen.</p>
        <Typography variant={"h6"} sx={wizardStyle.primary}>
          3. Belege hochladen
        </Typography>
        <p>
          Sie müssen Ihre Angaben mit Dokumenten belegen. Sie erfahren genau, welche Dokumente Sie brauchen und können diese dann einfach mit Ihrem Handy
          abfotografieren und hochladen.
        </p>

        <HighlightBox headline={"Hinweis"}>
          <p>Damit Sie das Formular vollständig ausfüllen können, halten Sie bitte (falls vorhanden) die folgenden Unterlagen bereit:</p>
          <ul>
            <li>Ihren Mietvertrag</li>
            <li>Ihre Lohnabrechnung des letzten Monats, Ihren Arbeitslosengeld-Bescheid oder Ihren Rentenbescheid</li>
          </ul>
        </HighlightBox>

        <FormSubmit nextText={"Jetzt starten"} hideBackButton={true} {...submitProps} />
      </Box>
    </Paper>
  );
}
